export default class WorkflowRegistryError extends Error {
    constructor(code, message, details = {}) {
        super(message)

        this.name = 'WorkflowRegistryError'
        this.code = code
        this.details = details
    }
}
